import { render, staticRenderFns } from "./subordinateAgency.vue?vue&type=template&id=19eddc95&scoped=true"
import script from "./subordinateAgency.vue?vue&type=script&lang=ts"
export * from "./subordinateAgency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19eddc95",
  null
  
)

export default component.exports